/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ManageCommunityInfo,
    ManageCommunityInfoFromJSON,
    ManageCommunityInfoFromJSONTyped,
    ManageCommunityInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetAdminCommunityInfoResponse
 */
export interface GetAdminCommunityInfoResponse {
    /**
     * 
     * @type {ManageCommunityInfo}
     * @memberof GetAdminCommunityInfoResponse
     */
    communityInfo: ManageCommunityInfo;
}

export function GetAdminCommunityInfoResponseFromJSON(json: any): GetAdminCommunityInfoResponse {
    return GetAdminCommunityInfoResponseFromJSONTyped(json, false);
}

export function GetAdminCommunityInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAdminCommunityInfoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'communityInfo': ManageCommunityInfoFromJSON(json['communityInfo']),
    };
}

export function GetAdminCommunityInfoResponseToJSON(value?: GetAdminCommunityInfoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'communityInfo': ManageCommunityInfoToJSON(value.communityInfo),
    };
}


